import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { SignInTextCard } from '../SignInTextCard';
import audienceImage from '../assets/UCS_Sign_In_Audience-color.png';

const COPY = defineMessages({
  HEADLINE: {
    id: 'AudienceSignInTextCard.title',
    defaultMessage: 'Need people to take your survey?',
    description: '[Type: Header][Vis.: low] -  AudienceSignInTextCard title',
  },
  MESSAGE: {
    id: 'AudienceSignInTextCard.message',
    defaultMessage:
      'SurveyMonkey Audience has millions of qualified respondents ready to take your surveys. Get responses in 2 days.',
    description:
      '[Type: Paragraph][Vis.: low] - AudienceSignInTextCard message',
  },
});

export const AudienceSignInTextCard: React.FC = () => {
  return (
    <SignInTextCard
      headline={t(COPY.HEADLINE)}
      message={t(COPY.MESSAGE)}
      image={() => <img src={audienceImage} alt="" aria-hidden="true" />}
    />
  );
};

export default AudienceSignInTextCard;
